import React from 'react'
import { UserIcon } from '../../application'
import { InviteUser } from './components'
import getText from '../strings'
import { colors } from '../../styles'
import { css } from 'react-emotion'

export default ({ ...user }) => (
  <InviteUser>
    <UserIcon {...user} />
    <div>
      <h4>{user.firstName}</h4>
    </div>
    <div className={css`color: ${colors.tui_grey};`}>{getText('manage', 'leadPassenger')}</div>
  </InviteUser>
)